import React, { useEffect, useState } from 'react';
import isNil from 'lodash/isNil';
import { INTEGRATION_INVITATION_COOKIE } from 'constants';
import { Loader } from 'components/ui';
import sessionStore from 'services/session_store';

export const getIntegrationInvitationCookie = () => {
  return sessionStore.get(INTEGRATION_INVITATION_COOKIE);
};

export const setIntegrationInvitationCookie = (token) => {
  sessionStore.set(INTEGRATION_INVITATION_COOKIE, token);
};

export const removeIntegrationInvitationCookie = () => {
  sessionStore.delete(INTEGRATION_INVITATION_COOKIE);
};

const WithIntegrationInvitationTokenParameter = ({ children }) => {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const integrationInvitationToken = urlParams.get(
      'integration_invitation_token',
    );
    if (!isNil(integrationInvitationToken)) {
      setIntegrationInvitationCookie(integrationInvitationToken);
    }
    setLoading(false);
  }, []);
  if (loading) {
    return <Loader />;
  }
  return children;
};

export default WithIntegrationInvitationTokenParameter;
